export const AUTH_VERIFY_EMAIL_REQUEST = 'auth/verify-email-request'
export const AUTH_VERIFY_EMAIL_SUCCESS = 'auth/verify-email-success'
export const AUTH_VERIFY_EMAIL_FAILED = 'auth/verify-email-failed'
